import React from 'react';
import { Route } from 'react-router-dom';

import PageNotFound from '../../../Routes/404';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
// import Denied from '../../../Routes/Denied';

const ConditionalRoute = ({ isVisible, roleRequired, children, ...props }) => {
    const { userRole } = useSelector((state) => state.auth);
    console.log(isVisible, 'isvisible');

    if (isVisible) {
        return <Route {...props}>{children}</Route>;
    } else {
        return (
            <Route {...props}>
                <PageNotFound />
            </Route>
        );
    }

    // if (!isVisible) {
    //     return <Route {...props} component={PageNotFound} />;
    // } else {
    //     if (roleRequired && !roleRequired.includes(userRole)) {
    //         return <Route {...props} component={PageNotFound} />;
    //     } else {
    //         return <Route {...props}>{children}</Route>;
    //     }
    // }
    
    
};

export default ConditionalRoute;
